export default __webpack_public_path__ + "static/media/green1.795924d2.svg";